import { StorefrontIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip, Tooltip } from '@reveni-io/reveni-ui'

import ChipLabel from './ChipLabel/ChipLabel'
import PortalItem from './PortalItem/PortalItem'
import * as Styles from './styles'

const PortalsInUseList = ({ portals, portalsInUse = [] }) => {
  const theme = useTheme()

  if (!portals?.length) return null

  const renderPortalsInUse = () => {
    const portalsInUseList = portals.filter(portal => portalsInUse.includes(portal.id))

    if (!portalsInUseList.length) return ''

    return (
      <Styles.PortalsList>
        {portalsInUseList.map(portal => (
          <PortalItem key={portal.id} portal={portal} />
        ))}
      </Styles.PortalsList>
    )
  }

  return (
    <Tooltip title={renderPortalsInUse()}>
      <Styles.Container>
        <Chip
          label={<ChipLabel portals={portals} portalsInUse={portalsInUse} />}
          Icon={StorefrontIcon}
          color={theme.colors.info.onSurface}
        />
      </Styles.Container>
    </Tooltip>
  )
}

export default PortalsInUseList
